export const STATUSES = ["awaiting", "checked_in", "checked_out"];

export const TITLES = {
  awaiting: "Awaiting check-in",
  checked_in: "Checked in",
  checked_out: "Checked out",
};

export function statusFor({ checkedIn, checkedOut }) {
  if (checkedOut) return "checked_out";
  if (checkedIn) return "checked_in";
  return "awaiting";
}

export function countStatuses(statuses) {
  const counts = { awaiting: 0, checked_in: 0, checked_out: 0 };
  statuses.forEach((status) => {
    if (status in counts) counts[status] += 1;
  });
  return counts;
}

export function summaryLabel(shown, total) {
  return `${shown} of ${total} dog${total === 1 ? "" : "s"} booked today · sorted by time`;
}
